import request from './apiBase'

class ApiQuestion {

    static getInvite(params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/open/invite/info',
                method: 'get',
                params: params,
            }).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    }

    static getVideo(params) {
        return new Promise((resolve, reject) => {
            request({
                url: `/open/video/play/info`,
                method: 'get',
                params: params,
            }).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    }

}

export default ApiQuestion